export enum TelegramChatStatusesEnum {
  INITIAL = 'INITIAL',
  PROCESSED = 'PROCESSED',
  CLOSED = 'CLOSED',
}

export enum MessageContentTypesEnum {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}
